import { all_routes } from "./all_routes";
const route = all_routes;
export const SidebarData = [
    
  {
    label: "",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Home",
        icon: "",
        submenu: false,
        showSubRoute: false,
        link:route.Home,
      },
      {
        label: "Who We Serve",
        icon: "ti ti-brand-airtable",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Type",
            // link:route.chat,
            submenu: true,
            showSubRoute: false,
            submenuItems: [
                { label: "Start ups", link: route.StartUps },
                { label: "Scaleups", link:route.Scaleups },
                { label: "Enterprises", link: route.Enterprises },
                { label: "NGOs", link: route.ITFirms },

              ],
          },
          {
            label: "Industries",
            submenu: true,
            submenuItems: [
              { label: "Banking & Finance", link: route.BankingFinance },
              { label: "Retail & Commerce", link:route.RetailCommerce },
              { label: "Food & Beverages", link: route.FoodBeverages },
              { label: "Educationa", link: route.Education },
              { label: "Healthcare", link:route.Healthcare },
              { label: "Real Estate", link: route.Sports },
              { label: "Social Networking", link:route.SocialNetworking },
              { label: "Travel & Hospitality", link: route.TravelHospitality },
              { label: "Supply Chain & Logistics", link: route.SupplyChain },

            ],
          },
         
      
        ],
      },
      {
        label: "What we do",
        icon: "ti ti-brand-airtable",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Product Engineering",
            link:route.ProductEngineering,
            submenu: true,
            showSubRoute: false,
            submenuItems: [
                { label: "Discovery", link: route.Discovery },
                { label: "UX/UI Design", link:route.UXUIDesign },
                { label: "Product Development", link: route.ProductDevelopment },
                { label: "Digital Transformation", link: route.DigitalTransformation },
                { label: "ChatGPT Integration", link: route.ChatGPTIntegration },
              ],
          },
          {
            label: "Web Development",
            submenu: true,
            link:route.WebsiteDevelopment,
            showSubRoute: false,
            submenuItems: [
              { label: "Angular", link: route.Angular },
              { label: "React", link:route.Reactjs },
              { label: "Vue", link: route.Vue },
              { label: "Node", link: route.Node },
              { label: ".Net", link:route.DotNet },
              { label: "Java", link: route.Java },
              { label: "Python", link:route.Python },
             ],
          },
          {
            label: "Mobile Development",
            submenu: true,
            link:route.MobileAppDevelopment,
            showSubRoute: false,
            submenuItems: [
              { label: "Android App Development", link: route.AndroidAppDev },
              { label: "iOS App Development", link:route.IOSApp },
              { label: "React Native", link: route.ReactNative },
              { label: "Flutter", link: route.Flutter }, ],
          },
          {
            label: "DevOps Solutions",
            submenu: true,
            link:route.DevOps,
            showSubRoute: false,
            submenuItems: [
              { label: "DevOps Consulting", link: route.Consulting },
              { label: "CI/CD Development", link:route.CICD },
              { label: "Cloud Engineering", link: route.CloudEng },
              ],
          },
          {
            label: "QA & Management",
            submenu: true,
            link:route.QAManagement,
            showSubRoute: false,
            submenuItems: [
              { label: "Quality Assurance", link: route.QualityAssurance },
              { label: "Product Management", link:route.ProductManagement },
              { label: "Project Management", link: route.ProjectManagement },
              { label: "App Support & Maintenance", link: route.AppSupport },
              { label: "App Modernization", link:route.AppModernization },
             
              ],
          },
          {
            label: "Talent Solution",
            submenu: true,
            link:route.TalentSolution,
            showSubRoute: false,
            submenuItems: [
              { label: "Build Your Team", link: route.BuildYourTeam },
              { label: "Hire Developer", link:route.HireDeveloper },
              
              ],
          },
        ],
      },
         {
        label: "consultancy",
        icon: "",
        submenu: false,
        showSubRoute: false,
        link:route.Consultany,
      },
      {
        label: "Marketing",
        icon: "ti ti-brand-airtable",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Digital Marketing",
            link:route.DigitalMarketing,
            submenu: true,
            showSubRoute: false,
            submenuItems: [
                { label: "SEO", link: route.Sco },
                { label: "Email Marketing", link:route.EmailMarketing },
                { label: "Content Marketing", link: route.ContentMarketing },
          
              ],
          },
          {
            label: "Brand Activation",
            submenu: true,
            link:route.BrandActivation,
            showSubRoute: false,
            submenuItems: [
              { label: "Brand Strategy", link: route.BrandStrategy },
              { label: "Digital campaigns", link:route.Digitalcampaigns },
              { label: "Influencer collaboration", link: route.Influencercollaboration },
      
             ],
          },
          {
            label: "Develop",
            link:route.Develop,
            showSubRoute: false,
            submenu: true,
            submenuItems: [
              { label: "Website Development", link: route.WebsiteDevelopment },
              { label: "Mobile App Development", link:route.MobileAppDevelopment },
              ],
          },
          {
            label: "Design",
            link:route.Design,
            showSubRoute: false,
            submenu: true,
            submenuItems: [
              { label: "UI/UX Design", link: route.UXUIDesign },
              { label: "Web Design", link:route.WebDesign },
              { label: "Graphic Design", link: route.GraphicDesign },
              { label: "2D/3D Animations", link: route.Animations },

              ],
          },
     
        ],
      },
      {
        label: "Capabilities",
        icon: "ti ti-brand-airtable",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Front-end",
            link:route.FontEnd,
            submenu: true,
            showSubRoute: false,
            submenuItems: [
                { label: "HTML5/CSS3", link: route.HtmlCss },
                { label: "Bootstrap", link:route.Bootstrap },
                { label: "Vue.js", link: route.Vue },
                { label: "GatsbyJS", link: route.Gatsby },
                { label: "Angular", link: route.Angular },
                { label: "React", link: route.Reactjs },
                { label: "JavaScript", link: route.JavaScript },
              ],
          },
          {
            label: "Backend",
            submenu: true,
            link:route.BackEnd,
            showSubRoute: false,
            submenuItems: [
              { label: "Dot Net", link: route.DotNet },
              { label: "Java", link:route.Java },
              { label: "Python", link: route.Python },
              { label: "Node", link: route.Node },
        
             ],
          },
          {
            label: "Trending Tech",
           
            submenu: true,
            submenuItems: [
              { label: "AI Integration", link: route.AIIntegration },
              { label: "Blockchain", link:route.Blockchain },
              { label: "Big Data", link: route.BigData },
               ],
          },
          {
            label: "Database",
            submenu: true,
            submenuItems: [
              { label: "SQL Server", link: route.SQLServer },
              { label: "FIreStore", link:route.FIreStore },
              { label: "PostgreSQL", link: route.PostgreSQL },
              { label: "MySQl", link: route.MySQL },
              { label: "MongoDB", link: route.MongoDB },
              ],
          },
          {
            label: "Cloud",
            submenu: true,
            submenuItems: [
              { label: "AWS", link: route.Aws },
              { label: "Azure", link:route.Azure },
              { label: "GCP", link: route.GCP }
             
             
              ],
          },
          {
            label: "CMS",
            submenu: true,
            submenuItems: [
              { label: "WordPress", link: route.WordPress },
              { label: "JAMStack", link:route.JAMStack },
              { label: "WooCommerce", link:route.WooCommerce },
              ],
          },
        ],
      },
      {
        label: "About",
        icon: "ti ti-brand-airtable",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Our story",
            link:route.OurStory,
            submenu: false,
            showSubRoute: false,
          },
          {
            label: "Careers",
            link:route.Careers,
            submenu: false,
            showSubRoute: false,
          },
         
          {
            label: "Life at Alphai",
            link:route.LifeAtAlphai,
            submenu: false,
            showSubRoute: false,
          },
          {
            label: "Engagement models",
            link:route.EngagementModels,
            submenu: false,
            showSubRoute: false,
          },
        
        ],
      },
    ],
  },


 
];
